import SeoArticleLayout from '@/components/feature/SeoArticleLayout';
import { seoArticles } from '@/mocks/seo-articles';

export default function TrendingTikTokPage() {
  return <SeoArticleLayout article={seoArticles[3]} />;
}